module.exports = __webpack_public_path__ + "img/202305230002_1280_pickUp.6dade1d4.jpg";